export const freestyleMetaData = {
    isRepeatable: false
}
